import React from 'react';

import {Divider, Typography, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import {VIEW_STATE} from './index.js';

import {ZmPrimaryBtn} from 'Components/ZmButtons';
import {AvatarGroup} from 'Utils/CardDisplay';
import zoomPalette from 'zoomPalette';

/**
 * Adding the footer
 * @param {Object} props
 * @return {ReactElement}
 */
export default function VotingFooter(props) {
  const {
    isBookerVoting,
    setCurrView,
    votes,
  } = props;
  const theme = useTheme();
  const {t} = useTranslation();
  const votesArr = isBookerVoting ? Object.values(votes) : [];
  const votesVisible = useSelector((s) => s.bookAppointments.appt?.votesVisible);
  const voters = useSelector((s) => s.bookAppointments.appt?.voters);

  return (
    <footer
      style={{
        position: 'sticky',
        bottom: '-8px',
        backgroundColor: theme.palette.background.default,
      }}>
      <Divider fullWidth/>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 0',
        ...(votesVisible && voters ? {
          justifyContent: 'space-between',
        } : {
          justifyContent: 'flex-end',
        }),
      }}>
        {
          votesVisible && voters &&
              <div style={{display: 'flex', alignItems: 'center'}}>
                <Typography
                  sx={{
                    fontSize: '.875rem',
                    fontWeight: 510,
                    lineHeight: '1.25rem',
                    marginRight: '6px',
                  }}
                >
                  {t('polls.voters')}
                </Typography>
                <AvatarGroup
                  users={voters}
                />
              </div>
        }
        <div style={{display: 'flex', alignItems: 'center'}}>
          <Typography
            sx={{
              marginRight: '16px',
              fontSize: '.875rem',
              fontWeight: 510,
              lineHeight: '1.25rem',
              color: zoomPalette.blue[70],
            }}>
            {votesArr.length === 1 ? t('apptForm.timeSelected', [votesArr.length]) :
                  t('apptForm.timesSelected', [votesArr.length])}
          </Typography>
          <ZmPrimaryBtn
            disabled={votesArr.length === 0}
            size="small"
            onClick={() => setCurrView(VIEW_STATE.FORM_VIEW)}
          >
            {t('common.next')}
          </ZmPrimaryBtn>
        </div>
      </div>
    </footer>
  );
}
